export const getUrlParamValue = (name) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
};
//# sourceMappingURL=getUrlParamValue.js.map